<template>
  <div id="inside" :class="largura >= 500 ? 'page-wrapper-desktop' : ''">
    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'">
      <div :class="largura < 500 ? 'mx-3' : ''">
        <div class="row">
          <div class="col-12 text-body px-2 mb-2">
            <button
              class="justify-content-left text-decoration-none btn-link flex-row d-flex align-items-center pr-2 pb-2 pl-1 text-primary"
              style="background-color: transparent !important;"
              @click="home()">
              <i class="fa fa-chevron-left fa-fw pull-left text-info"></i>
              Voltar
            </button>
          </div>
        </div>
        <div class="row" v-if="debtsConsorcio && !loadOffers">
          <div class="col-12 text-body pr-0">
            <h5 class="text-bold mt-2">Você está negociando</h5>
            <HeaderOptions />
          </div>
        </div>
      </div>
    </div>

    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="debtsConsorcio && !loadOffers">
      <div :class="largura < 500 ? 'card pt-4 pb-4 mx-3' : 'card pt-4 pb-4'">
        <div class="col-12">
          <h5 class="mb-0 d-flex align-items-center">
            {{ fromToConsorcioProduct[debtsConsorcio[0].product] }}
          </h5>
        </div>
        <div class="d-flex col-lg-12 col-12">
          <p class="mr-2 mb-0">Contrato:</p>
          <p class="text-bold mb-0" style="font-weight: bold">
            {{
              debtsConsorcio[0].contract
            }}
          </p>
        </div>
        <div class="d-flex col-lg-12 col-12">
          <p class="mr-2 mb-0">Grupo:</p>
          <p class="text-bold mb-0" style="font-weight: bold">

            {{
              debtsConsorcio[0].group
            }}
          </p>
        </div>
        <div class="d-flex col-lg-12 col-12">
          <p class="mr-2 mb-0" style="font-size: 10pt">
            Cota:
          </p>
          <p class="text-bold mb-0" style="font-weight: bold">
            {{ debtsConsorcio[0].cota }}
          </p>
        </div>
        <div class="d-flex col-lg-12 col-12">
          <p class="mb-0" style="font-size: 10pt; font-weight: bold">
            {{ fromToConsorcioType[debtsConsorcio[0].type] }}
          </p>
        </div>
      </div>
    </div>

    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="debtsConsorcio && !loadOffers">
      <div :class="largura < 500 ? 'mx-3' : ''">
        <div class="row">
          <div class="col-12 text-body pr-0">
            <h5 class="text-bold mt-3" style="color: black">
              Selecione as parcelas a negociar
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-for="(value, key, index) in debtsConsorcio"
      :key="`${key}-${index}`">
      <div :class="largura < 500 ? 'card mb-4 mx-3' : 'card'">
        <!-- <div class="card-header">
          <div class="row">
            <div class="col-12">
              <p class="ml-2 mt-2" style="font-weight: bold; color: black">
                Pagamento à vista
              </p>
            </div>
          </div>
          <hr class="mt-0" />
        </div> -->
        <div class="card-body mt-0 pt-0">
          <div class="row">
            <div class="col-12">
              <h5>
                Pagamento à vista
              </h5>
              <hr>
            </div>
            <div class="col-12">
              <h5>
                Parcelas
              </h5>
              <p class="mb-2 ml-1" style="font-style: italic; color: black; font-size: 12px">
                Selecione as parcelas que deseja negociar
              </p>
            </div>
          </div>
          <!-- <div class="row mt-4">
            <div class="col-lg-12 d-flex align-items-center col-12" style="justify-content: end; font-style: italic">
              <p class="mr-2 mt-1 mb-1 small">
                Selecionar todas as parcelas disponíveis
              </p>
              <input type="checkbox" v-model="value.selected"
                :disabled="thereIsAgreementCdcClosed(value.contract) || loadOffers"
                @change="selectAllParcelsContract(value)" />
            </div>
          </div> -->
          <div class="row">
            <div class="col-lg-12 col-12 mb-3" style="">
              <div class="col-12" v-if="largura > 500">
                <div class="row" style="
                    background-color: white;
                    min-height: 10px;
                    margin-bottom: -2px;
                  "></div>
              </div>
              <div class="col-12" v-if="largura < 500">
                <div class="row" style="
                    background-color: white;
                    min-height: 15px;
                    margin-bottom: -10px;
                  "></div>
              </div>
              <div class="table-responsive" :style="value.installments.length > 4
                ? 'height: 14rem;'
                : 'height: auto; overflow-y: auto;'
                ">
                <div class="table-container">
                  <div class="custom-table">
                    <div class="table-row table-header">
                      <div class="table-cell header">Selecionar</div>
                      <div v-bind:class="largura > 500
                        ? 'table-cell header text-center'
                        : 'table-cell header'
                        ">
                        Nº Parcela
                      </div>
                      <div class="table-cell header">Vencimento</div>
                      <div class="table-cell header text-center">Valor</div>
                    </div>
                    <div v-bind:class="largura < 500 ? 'table-row mr-2' : 'table-row'"
                      v-for="(value1, key1, index1) in value.installments" :key="`${key1}-${index1}`">
                      <div class="table-cell">
                        <input id="checkParcels" type="checkbox" v-model="checkedParcels" :value="value1"
                          :disabled="thereIsAgreementCdcClosed(value.contract) || loadOffers || !canToggleInstallment(value1, value)"
                          @change="calculateSingleInstallment(value1, value)" />
                      </div>
                      <div class="table-cell text-center">
                        {{ getInstallmentNumberLabel(value1) }}
                      </div>
                      <div class="table-cell text-center">
                        {{ formatData(value1.dueDate, "YYYY-MM-DD", "L") }}
                      </div>
                      <div v-bind:class="largura > 500
                        ? 'table-cell text-center'
                        : 'table-cell'
                        ">
                        {{
                          formatFloatToReal(
                            parseFloat(value1.originalValue, 10)
                          )
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="d-flex col-12 col-lg-12" style="align-items: center; font-style: italic">
              <p class="mb-0 mr-2">Total de parcelas selecionadas:</p>
              <h6 class="mt-2">
                <b>{{
                  value.selected || value.parcelsIsFromCurrentContract
                    ? checkedParcels.length
                    : 0
                }}</b>
              </h6>
            </div>
            <div class="d-flex col-12 col-lg-12" style="align-items: center; font-style: italic">
              <p class="mb-1 mr-2">Valor total selecionado:</p>
              <h6 class="mt-1">
                <b>{{
                  value.selected || value.parcelsIsFromCurrentContract
                    ? sumByContract(checkedParcels)
                    : "R$0,00"
                }}</b>
              </h6>
            </div>
          </div>
          <div class="row mt-3">
            <div class="text-center col-md-12 mt-1">
              <button :class="{
                'alert-flashing': checkedParcels.length > 0 && needUpdate,
              }" style="
                  width: 100%;
                  border-radius: 20px;
                  background-color: #e7ebfd;
                  padding: 10px;
                " :disabled="(checkedParcels.length <= 0 && !needUpdate) ||
                  thereIsAgreementCdcClosed(value.contract)
                  " v-if="!loadOffers" @click="loadOffersConsorcio()">
                Atualizar valores
              </button>
              <div class="container" v-if="loadOffers || loadingMoreOptions">
                <ProgressLoading v-bind:loading="loadOffers || loadingMoreOptions" />
              </div>
            </div>
          </div>
          <hr />
          <div v-if="cardOffers && !loadOffers && !needUpdate && cardOffers.paymentOptions && cardOffers.paymentOptions.length > 0" id="cardOfferUpdated">
            <div class="row mt-3" v-for="(value1, key2, index2) in cardOffers.paymentOptions"
              :key="`${key2}-${index2}`">
              <div class="d-flex flex-column col-8">
                <div class="text-info" style="display: flex; margin-bottom: 0">
                  <p class="ml-2 mb-0">Valor total do acordo:</p>
                </div>
                <div class="text-info" style="display: flex; margin-bottom: 0" v-if="value1.discount && parseFloat(value1.discount) > 0">
                  <p class="ml-2 mb-0">De <span style="text-decoration: line-through; margin-bottom: 0">{{
                    sumByContract(checkedParcels) }}</span> por</p>
                </div>

                <div class="ml-2 mb-0" style="margin-bottom: 0; font-weight: bold">
                  <p class="mb-0" style="font-size: 18px">
                    R$
                    {{
                      (value1.value || value1.paymentValue || 0).toLocaleString("pt-BR", {
                        currency: "BRL",
                        minimumFractionDigits: 2,
                      })
                    }}
                  </p>
                </div>
                <div class="mb-0" style="margin-bottom: 0">
                  <p class="ml-2" style="font-size: 9pt; margin-bottom: 0">
                    Vencimento do acordo:
                    {{ formatData(cardOffers.dueDate || value1.dueDate || offerInfo.offerDueDate, "YYYY-MM-DD", "L") }}
                  </p>
                </div>
              </div>
              <div v-bind:class="largura < 500 ? 'col-4 text-center' : 'col-4 text-right pr-5'"
                v-if="value1.discount && parseFloat(value1.discount) > 0">
                <p class="mb-0" style="font-size: 9pt">Desconto de</p>
                <span class="text-white" style="
                    display: inline-block;
                    background-color: #88cd31;
                    border-radius: 20px;
                    padding: 5px 5px;
                    text-align: center;
                    width: auto;
                    font-size: 14pt;
                  ">
                  {{ Math.abs(parseFloat(value1.discount)) }}%
                </span>
              </div>
              <div class="text-center col-md-12 mt-3">
                <button class="btn mb-2 btn-primary p-3" style="width: 100%; border-radius: 20px" :disabled="needUpdate || thereIsAgreementCdcClosed(value.contract)
                  " @click="resumoAcordo(value1, false)">
                  PAGAR
                </button>
              </div>
            </div>
          </div>
          <div class="row mt-3 mb-4 px-2" v-if="thereIsAgreementCdcClosed(value.contract)">
            <div class="col-lg-1 text-center px-1 col-1">
              <i class="fa fa-info-circle text-danger"></i>
            </div>
            <div class="px-1 col-lg-11 col-11">
              <p class="small">
                Existe um acordo em andamento, por isso não é possível fazer uma
                nova negociação.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="!debtsCdc && !loadOffers">
      <div class="row">
        <div class="align-items-center justify-content-center col-sm-12 col-12 d-flex col-md-12 col-lg-12 px-4">
          <i class="fa fa-2x fa-exclamation-circle pull-left mr-4 mb-2 text-primary"></i>
          <h4 class="py-4 text-primary">
            No momento não temos uma oferta disponível para você.
          </h4>
        </div>
      </div>
      <div class="row pb-5">
        <div class="align-items-center justify-content-center col-sm-12 col-12 d-flex col-md-12 col-lg-12 px-4">
          <h6 class="py-2 text-muted">
            Conte com a gente para ter um alívio financeiro! É só selecionar o
            produto e acionar o atendimento que preferir:
          </h6>
        </div>
      </div>
      <div class="row mb-5">
        <div class="col-12 col-lg-3 px-4">
          <h4 class="py-4">Central de Relacionamento Cartão de Crédito</h4>
          <p>
            <a href="tel:40043600" target="_blank">4004 3600</a> - Capitais e
            regiões metropolitanas.&nbsp;<br /><a href="tel:08007277477" target="_blank">0800 727 7477</a>
            - Demais localidades.&nbsp;<br /><a href="tel:551133663216" target="_blank">+55 11 3366 3216</a>
            - Atendimento no exterior.&nbsp;<br />De segunda a sexta-feira, das
            8h às 18h30.
          </p>
        </div>
        <div class="p-0 px-4 col-12 col-lg-3">
          <h4 class="py-4">
            Central de Relacionamento Cartão de Crédito Empresarial
          </h4>
          <p>
            <a href="tel:1140043600" target="_blank">4004 3600</a> - Capitais e
            regiões metropolitanas.<br /><a href="tel:08007277477" target="_blank">0800-727-7477</a>
            - Demais localidades.&nbsp;<br />De segunda à sexta das 7h40 às
            19h00.
          </p>
        </div>
        <div class="p-0 px-4 col-12 col-lg-3">
          <h4 class="py-4">
            Central de Relacionamento Empréstimo e Financiamento
          </h4>
          <p>
            <a href="tel:40045215" target="_blank">4004 5215</a>&nbsp;<br />De
            segunda a sexta-feira, das 8h às 19h (exceto feriados).
          </p>
        </div>
        <div class="p-0 px-4 col-12 col-lg-3">
          <h4 class="py-4">SAC</h4>
          <p>
            <a href="tel:08007272745" target="_blank">0800 727 2745</a><br />Atendimento 24 horas.
          </p>
        </div>
      </div>
    </div>

    <div :class="largura >= 500 ? 'container container-centered-desktop' : 'container'" v-if="cardOffers && !loadOffers">
      <div class="row" v-if="!loadOffers"></div>
    </div>
    <!-- <div class="container" v-if="loadOffers || loadingMoreOptions">
      <ProgressLoading v-bind:loading="loadOffers || loadingMoreOptions" />
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  formatCurrencieValueBRL as formatValue,
  formatData,
  truncateString,
  formatFloatToReal,
  getEaster,
  getBrazilianHolidays,
  isBusinessDay,
} from "@/utils/helpers";
import {
  canUncheckInstallment,
  canCheckInstallment,
  getAutoSelectInstallments,
  getInitialAutoSelectInstallments,
  getErrorMessage,
} from "@/utils/consorcioNegotiationRules";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
import HeaderOptions from "../components/HeaderMenu.vue";
import { VMoney } from "v-money";
import { initializeGlobals } from "@/global";
import moment from "moment";

export default {
  name: "propostas-consorcio",
  components: {
    ProgressLoading,
    HeaderOptions,
  },
  directives: {
    money: VMoney,
  },
  data() {
    return {
      form: {
        offerSelected: null,
      },
      loadOffers: false,
      loadOffersWithEntry: false,
      offers: [],
      offerInfo: [],
      largura: null,
      installment: {},
      loadSetAgreement: false,
      cardOffers: null,
      otherOptionsInstallment: null,
      newOffersLoaded: false,
      othersOptionsLoaded: false,
      selectedOption: {},
      selectedOptionEntryValue: {},
      paymentOptionsId: [],
      isContencioso: false,
      entryValue: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false /* doesn't work with directive */,
      },
      responseWithEntryValue: [],
      entryValueFinal: null,
      loadingMoreOptions: false,
      lastOptionCalled: null,
      count: 0,
      userDataStorage: {},
      pageLocation: null,
      protocol: null,
      path: null,
      host: null,
      userAdm: {},
      ipUser: null,
      debtsCdc: [],
      checkedParcels: [],
      needUpdate: false,
      agreements: [],
      installmentsSelected: [],
      fromToConsorcioProduct: {
        'IMV': 'CONSORCIO - IMÓVEIS',
        'AUT': 'CONSORCIO - AUTOMÓVEIS'
      },
      fromToConsorcioType: {
        'nao contemplado': 'Ativa (não contemplado)',
        'contemplado sem bem': 'Ativa (contemplado sem bem)',
        'contemplado com bem': 'Ativa (contemplado com bem)'
      },
    };
  },
  methods: {
    formatValue,
    formatData,
    truncateString,
    formatFloatToReal,
    getEaster,
    getBrazilianHolidays,
    isBusinessDay,

    ...mapActions("meusContratos", ["ActionGetOffersPortoSeguro"]),

    async loadOffersConsorcio() {
      //eslint-disable-next-line
      // debugger;
      
      // Validação: verifica se há pelo menos uma parcela selecionada
      if (!this.checkedParcels || this.checkedParcels.length === 0) {
        this.flashMessage.show({
          timeout: 3000,
          status: "error",
          title: "Aviso",
          message: "Você deve selecionar pelo menos uma parcela para continuar.",
        });
        return;
      }
      
      this.loadOffers = true;
      // if (this.$route.params.from === "resumoAcordo") {
      //   this.offerInfo = this.$route.params.offerInfo;
      // } else {
      //   this.offerInfo = this.$route.params.offerInfo;
      // }

      // const nextBusinessDay = this.getNextBusinessDay();

      try {
        this.installmentsSelected = this.checkedParcels.map((value) => {
          return {
            dueDate: value.dueDate,
            installmentNumber: value.installmentNumber,
            installmentId: value.installmentId,
          };
        });

        // Calcula o valor total apenas das parcelas selecionadas
        const selectedPaymentValue = this.checkedParcels.reduce((total, parcel) => {
          return total + parseFloat(parcel.paymentValue || parcel.originalValue || 0);
        }, 0);

        console.log("installmentsSelected: " + JSON.stringify(this.installmentsSelected));
        console.log("selectedPaymentValue: " + selectedPaymentValue);
        console.log("offerInfo: " + JSON.stringify(this.offerInfo));

        var result = await this.ActionGetOffersPortoSeguro({
          clientCode: this.offerInfo.clientCode,
          credor: this.offerInfo.credor,
          installmentsOptions: [1, 4],
          agreementType: "ParcelamentoRecupera",
          contract: this.offerInfo.contract,
          discount: 0,
          inputValue: 0,
          paymentType: "Boleto",
          paymentValue: selectedPaymentValue,
          contracts: [
            {
              contract: this.offerInfo.contract,
              product: this.offerInfo.product,
              installments: this.installmentsSelected,
            },
          ],
          daysDelay: this.offerInfo.daysDelay,
          tag: localStorage.getItem("tag"),
          UserID: this.userAdm ? this.userAdm.UserID : null,
          UserFullName: this.userAdm ? this.userAdm.UserFullName : null,
          OS: navigator.platform,
          IP: this.ipUser ? this.ipUser : "",
        });

        // Processar a resposta da API corretamente
        // A estrutura é: result.data.results ou result.results
        const responseData = result.data?.results || result.results || result.data || result;
        this.cardOffers = responseData;
        this.loadOffers = false;
        this.needUpdate = false;
      } catch (error) {
        this.flashMessage.show({
          time: 3000,
          status: "error",
          position: "top right",
          title: "Erro",
          message:
            "Não foi possível buscar ofertas, tente novamente mais tarde!",
        });
        this.eventCallbackNegociarFailureGTM(error);
        // this.$router.push({
        //   name: "dashboard",
        // });
      } finally {
        setTimeout(() => {
          this.goToCardOfferUpdated()
        }, 1000);
        this.loadOffers = false;
      }
    },

    getNextBusinessDay() {
      const momentDate = moment(); // data de hoje
      const holidays = getBrazilianHolidays(momentDate.year());

      do {
        momentDate.add(1, "day"); // vai para o dia seguinte
      } while (!isBusinessDay(momentDate, holidays)); // repete até encontrar um dia útil

      return momentDate.format("YYYY-MM-DD");
    },

    resumoAcordoParcelasSelecionadas(contract) {
      // Calcula o valor total das parcelas selecionadas
      let totalSelected = 0;
      this.checkedParcels.forEach((parcel) => {
        totalSelected += parseFloat(parcel.originalValue || 0);
      });

      // Cria um objeto offer com os dados do contrato e valor total selecionado
      const offer = {
        clientCode: this.offerInfo.clientCode,
        credor: this.offerInfo.credor,
        product: this.offerInfo.product,
        contract: this.offerInfo.contract,
        paymentValue: totalSelected,
        value: totalSelected,
        dueDate: this.offerInfo.offerDueDate || this.offerInfo.dueDate,
        plan: 1,
        installmentsNumber: 1,
        installmentValue: totalSelected,
        group: this.offerInfo.group || contract.group,
        cota: this.offerInfo.cota || contract.cota,
      };

      this.eventClickNegociarGTM(offer);
      this.resumoAcordo(offer, false);
    },

    async resumoAcordo(offer, isWithEntryValue) {
      isWithEntryValue
      if (offer === null) {
        offer = this.selectedOption;
      }

      console.log("offer: " + JSON.stringify(offer));
      console.log("offerInfo: " + JSON.stringify(this.offerInfo));
      console.log("checkedParcels: " + JSON.stringify(this.checkedParcels));

      this.eventClickNegociarGTM(offer);

      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard/resumoAcordoConsorcio",
        "resumo-acordo"
      );
      this.updateCustomData();

      this.offerInfoOriginal = this.offerInfo;

      this.installmentsSelected = this.checkedParcels.map((value) => {
        return {
          dueDate: value.dueDate,
          installmentNumber: value.installmentNumber,
          installmentId: value.installmentId,
          originalValue: value.originalValue,
          paymentValue: value.paymentValue,
          situation: value.situation,
          C_PCTIPD: value.C_PCTIPD,
          c_pctipd: value.c_pctipd,
        };
      });


      // Garante que o valor do offer seja priorizado
      const offerValue = offer.value || offer.paymentValue;
      const offerPaymentValue = offer.paymentValue || offer.value;
      
      this.$router.push({
        name: "resumoAcordoConsorcio",
        params: {
          offerInfo: {
            // Primeiro espalha os dados do offerInfo (base)
            ...this.offerInfo,
            // Depois espalha os dados do offer (pode sobrescrever alguns campos)
            ...offer,
            // Mas garante que os valores críticos do offer sejam preservados
            clientCode: this.offerInfo.clientCode,
            credor: this.offerInfo.credor,
            product: this.cardOffers?.product || this.offerInfo.product,
            dueDate: this.cardOffers?.dueDate || offer.dueDate || this.offerInfo.offerDueDate,
            contract: this.cardOffers?.contract?.toString() || this.offerInfo.contract?.toString() || this.offerInfo.contract,
            // Prioriza o valor do offer selecionado
            value: offerValue || this.offerInfo.value || this.offerInfo.paymentValue,
            paymentValue: offerPaymentValue || offerValue || this.offerInfo.paymentValue || this.offerInfo.value,
            entryValue: isWithEntryValue ? this.entryValueFinal : 0,
            plan: offer.plan || this.cardOffers?.paymentOptions?.[0]?.plan || "1",
            installmentNumber: offer.installmentsNumber || this.cardOffers?.paymentOptions?.[0]?.installmentsNumber || 1,
            installmentValue: offer.installmentValue || offer.inputValue || offerValue || this.cardOffers?.paymentOptions?.[0]?.installmentValue || this.offerInfo.paymentValue,
            paymentOptionCode: this.cardOffers?.paymentOptionCode || null,
            paymentOptionsCodeIds: this.paymentOptionsId.length > 0 ? this.paymentOptionsId : (this.cardOffers?.paymentOptionCode ? [{ [this.cardOffers.paymentOptionCode]: [offer.installmentsNumber || 1] }] : []),
            agreementType: "ParcelamentoRecupera",
            invoiceOption: "Boleto",
            group: this.offerInfo.group || this.debtsConsorcio[0]?.group,
            cota: this.offerInfo.cota || this.debtsConsorcio[0]?.cota,
            installments: this.offerInfo.installments || this.debtsConsorcio[0]?.installments,
            expirationDate: this.cardOffers?.expirationDate,
            inputLimitDate: this.cardOffers?.inputLimitDate,
            discount: offer.discount || this.cardOffers?.paymentOptions?.[0]?.discount || 0,
          },
          cardOffers: this.cardOffers,
          debtsConsorcio: this.debtsConsorcio,
          isWithEntryValue: isWithEntryValue,
          sumTotalInstallmentsConsorcio: this.sumTotalInstallmentsConsorcio,
          installmentsSelected: this.installmentsSelected,
        },
      });
    },

    thereIsAgreementCdcClosed(contractNumber) {
      if (!contractNumber || this.agreements.length <= 0) {
        return;
      }
      var result =
        this.agreements.filter(function (val) {
          return val.contract === contractNumber;
        }).length > 0;

      return result;
    },

    sumByContract(checkedParcels) {
      let total = 0;
      checkedParcels.map((valueInstallment) => {
        total += parseFloat(valueInstallment.originalValue);
      });
      this.sumTotalInstallmentsConsorcio = total;
      return total
        .toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
        .replace("-", "");
    },

    selectAllParcelsContract(contract) {
      this.needUpdate = true;
      this.clearFlagsAnotherContracts(contract);

      if (contract.selected) {
        this.checkedParcels = [];
        this.checkedParcels = [
          ...this.checkedParcels,
          ...contract.installments,
        ];
      } else {
        this.checkedParcels = this.checkedParcels.filter(
          (parcel) => !contract.installments.includes(parcel)
        );
      }

      this.checkedParcels.map((parcel) => {
        this.valueTotal += parseFloat(parcel.originalValue);
      });
    },

    clearFlagsAnotherContracts(contract) {
      if (!contract) {
        return;
      }
      this.debtsConsorcio.map((item) => {
        if (item.contract !== contract.contract) {
          item.selected = false;
          item.parcelsIsFromCurrentContract = false;
        }
      });
    },

    /**
     * Rótulo da coluna Nº Parcela: diffInstallment → "Diferença de parcela anterior", cost → "Custas", senão installmentNumber.
     */
    getInstallmentNumberLabel(installment) {
      if (!installment) return "";
      const situation = (installment.situation || "").toLowerCase();
      const c_pctipd = String(installment.C_PCTIPD || installment.c_pctipd || "");
      const instNum = parseInt(installment.installmentNumber, 10);
      if (situation === "diffinstallment" || (instNum === 0 && c_pctipd === "2")) {
        return "Diferença de parcela anterior";
      }
      if (situation === "cost" || c_pctipd === "3") {
        return "Custas";
      }
      return installment.installmentNumber;
    },

    canToggleInstallment(installment, contract) {
      // Verifica se a parcela está selecionada
      const isSelected = this.checkedParcels.some(
        parcel => parcel.installmentId === installment.installmentId
      );

      // Se a parcela não está selecionada, verifica se pode marcar
      if (!isSelected) {
        return canCheckInstallment(installment, contract);
      }

      // Se está tentando desmarcar, verifica as regras de negociação de consórcio
      // IMPORTANTE: usa this.checkedParcels que contém a parcela atual (ainda não foi desmarcada)
      const uncheckResult = canUncheckInstallment(installment, contract, this.checkedParcels);
      
      console.log("[canToggleInstallment] Verificando se pode desmarcar:", {
        installmentNumber: installment.installmentNumber,
        installmentId: installment.installmentId,
        isSelected,
        canUncheck: uncheckResult.canUncheck,
        reason: uncheckResult.reason,
        checkedParcelsCount: this.checkedParcels.length
      });
      
      return uncheckResult.canUncheck;
    },

    async calculateSingleInstallment(installment, contract) {
      // Verifica se a parcela está no array agora (após o v-model ter processado)
      const isSelected = this.checkedParcels.some(
        parcel => parcel.installmentId === installment.installmentId
      );
      
      // Verifica se há outras parcelas do mesmo contrato selecionadas
      // Isso ajuda a distinguir entre "marcação inicial" e "desmarcação"
      const hasOtherParcelsFromContract = this.checkedParcels.some(
        parcel => contract.installments.some(inst => inst.installmentId === parcel.installmentId)
      );
      
      // Se a parcela NÃO está no array e há outras parcelas do contrato selecionadas, então foi uma desmarcação
      if (!isSelected && hasOtherParcelsFromContract) {
        // Adiciona a parcela de volta temporariamente para verificar as regras corretamente
        const tempCheckedParcels = [...this.checkedParcels, installment];
        
        // Verifica as regras de negociação de consórcio com a lista completa (incluindo a parcela sendo desmarcada)
        const uncheckResult = canUncheckInstallment(installment, contract, tempCheckedParcels);
        
        console.log("[calculateSingleInstallment] Tentativa de desmarcar:", {
          installmentNumber: installment.installmentNumber,
          installmentId: installment.installmentId,
          canUncheck: uncheckResult.canUncheck,
          reason: uncheckResult.reason,
          tempCheckedCount: tempCheckedParcels.length
        });
        
        if (!uncheckResult.canUncheck) {
          // NÃO permite desmarcar - BLOQUEIA a ação
          // Reverte a ação adicionando a parcela de volta
          this.checkedParcels.push(installment);
          
          // Verifica se o checkbox está desabilitado AGORA (após reverter)
          // Se estiver desabilitado, não mostra mensagem (UI já está bloqueando)
          const isNowDisabled = !this.canToggleInstallment(installment, contract);
          
          // Só mostra mensagem se o checkbox não está desabilitado
          // Se está desabilitado, significa que a UI já está impedindo, então não precisa de mensagem
          if (!isNowDisabled) {
            this.flashMessage.show({
              timeout: 2000,
              status: "error",
              title: "Aviso",
              message: getErrorMessage(uncheckResult.reason),
            });
          }
          return;
        }
        
        // REGRA: Parcelas C_PCTIPD=2 (diferença de parcela) NUNCA devem ser desmarcadas
        // Elas devem permanecer sempre selecionadas, independente das ações do usuário
        // Por isso, NÃO removemos automaticamente as parcelas C_PCTIPD=2
        
        // Se pode desmarcar, continua o fluxo normalmente (não faz return aqui)
      }

      if (this.checkedParcels.length <= 0) {
        this.clearFlagsAnotherContracts();
        return;
      }
      this.thereIsThisInstallmentInTheCheckedParcels(contract);
      this.valueTotal = 0;
      var orderCorrect = await this.controllerRuleByTypeCheckbox(contract);

      if (!orderCorrect) {
        this.flashMessage.show({
          timeout: 1000,
          status: "error",
          title: "Aviso",
          message: "Selecione parcela(s) em sequência!",
        });

        if (this.checkedParcels.length <= 0) {
          this.clearFlagsAnotherContracts();
        }

        if (
          parseInt(
            this.checkedParcels[this.checkedParcels.length - 1]
              .installmentNumber
          ) === installment.installmentNumber
        ) {
          let currentInstallment = this.checkedParcels;
          let index = currentInstallment.indexOf(installment);
          if (index > -1) {
            currentInstallment.splice(index, 1);
          }
          return;
        } else {
          this.checkedParcels.push(installment);
        }
        return;
      } else {
        // Se a parcela foi marcada e a ordem está correta, verifica se precisa selecionar automaticamente outras parcelas
        if (isSelected) {
          const autoSelectInstallments = getAutoSelectInstallments(contract, this.checkedParcels);
          
          // Seleciona automaticamente as parcelas C_PCTIPD=2 se necessário
          let hasNewSelections = false;
          autoSelectInstallments.forEach(autoInst => {
            const alreadySelected = this.checkedParcels.some(
              p => p.installmentId === autoInst.installmentId
            );
            if (!alreadySelected) {
              this.checkedParcels.push(autoInst);
              hasNewSelections = true;
            }
          });

          // Se foram selecionadas novas parcelas automaticamente, mostra mensagem informativa
          if (hasNewSelections) {
            this.flashMessage.show({
              timeout: 3000,
              status: "info",
              title: "Informação",
              message: "A diferença de parcela foi selecionada automaticamente conforme as regras de negociação.",
            });
          }
        }

        this.needUpdate = true;
        this.checkedParcels.map((value) => {
          this.valueTotal += parseFloat(value.originalValue, 10);
        });
      }
    },

    thereIsThisInstallmentInTheCheckedParcels(value) {
      this.checkedParcels.map((parcels) => {
        if (value.installments.includes(parcels)) {
          value.parcelsIsFromCurrentContract = true;
        }
      });
    },

    controllerRuleByTypeCheckbox(contract) {
      if (this.checkedParcels.length < 1) {
        return false;
      }

      // Verifica se há parcelas mistas (C_PCTIPD=1 e C_PCTIPD=2)
      const type1Parcels = this.checkedParcels.filter(p => p.C_PCTIPD === "1" || p.c_pctipd === "1");
      const type2Parcels = this.checkedParcels.filter(p => p.C_PCTIPD === "2" || p.c_pctipd === "2");
      const hasMixedTypes = type1Parcels.length > 0 && type2Parcels.length > 0;

      // Se só tem parcelas de diferença (C_PCTIPD=2), permite (será validado pelas regras de negociação)
      // Isso pode acontecer em alguns cenários de borda
      if (type1Parcels.length === 0 && type2Parcels.length > 0) {
        return true;
      }

      // Obtém apenas as parcelas C_PCTIPD=1 do contrato, ordenadas por installmentNumber
      const contractType1Installments = contract.installments.filter(
        inst => inst.C_PCTIPD === "1" || inst.c_pctipd === "1"
      ).sort((a, b) => parseInt(a.installmentNumber) - parseInt(b.installmentNumber));

      // Se há parcelas mistas, a validação de sequência deve considerar apenas as parcelas C_PCTIPD=1
      // A parcela de diferença (C_PCTIPD=2) não precisa estar em sequência com as demais
      if (hasMixedTypes) {
        // Ordena as parcelas C_PCTIPD=1 selecionadas
        const sortedType1Parcels = type1Parcels.sort((a, b) => {
          return parseInt(a.installmentNumber) - parseInt(b.installmentNumber);
        });

        // Verifica se a seleção de C_PCTIPD=1 começa pela parcela mais baixa desse tipo
        if (contractType1Installments.length > 0 && sortedType1Parcels.length > 0) {
          if (
            parseInt(sortedType1Parcels[0].installmentNumber) !==
            parseInt(contractType1Installments[0].installmentNumber)
          ) {
            return false;
          }
        }

        // CORREÇÃO: Verifica sequência considerando as parcelas DISPONÍVEIS no contrato
        // Não exige que sejam consecutivas numericamente, mas sim consecutivas nas disponíveis
        // Ex: Se o contrato tem parcelas 95 e 101, selecionar ambas é válido
        const isValidSequence = this.checkSequenceInAvailableInstallments(
          sortedType1Parcels,
          contractType1Installments
        );

        return isValidSequence;
      }

      // Comportamento padrão para parcelas do mesmo tipo (todas C_PCTIPD=1)
      const sortedCheckedParcels = this.checkedParcels.sort((a, b) => {
        return parseInt(a.installmentNumber) - parseInt(b.installmentNumber);
      });

      // Ordena as parcelas do contrato
      const sortedContractInstallments = [...contract.installments].sort((a, b) => {
        return parseInt(a.installmentNumber) - parseInt(b.installmentNumber);
      });

      // Verificar se a seleção começa pela parcela mais baixa disponível no contrato
      if (
        parseInt(sortedCheckedParcels[0].installmentNumber) !==
        parseInt(sortedContractInstallments[0].installmentNumber)
      ) {
        return false;
      }

      // CORREÇÃO: Verifica sequência considerando as parcelas DISPONÍVEIS no contrato
      // Não exige que sejam consecutivas numericamente, mas sim consecutivas nas disponíveis
      const isValidSequence = this.checkSequenceInAvailableInstallments(
        sortedCheckedParcels,
        sortedContractInstallments
      );

      return isValidSequence;
    },

    /**
     * Verifica se as parcelas selecionadas estão em sequência dentro das parcelas disponíveis
     * Ex: Se as disponíveis são [95, 101] e selecionadas são [95, 101], é válido
     * Ex: Se as disponíveis são [95, 96, 101] e selecionadas são [95, 101] (pulando 96), é inválido
     * @param {Array} selectedParcels - Parcelas selecionadas, ordenadas por installmentNumber
     * @param {Array} availableParcels - Parcelas disponíveis no contrato, ordenadas por installmentNumber
     * @returns {boolean} true se a sequência é válida
     */
    checkSequenceInAvailableInstallments(selectedParcels, availableParcels) {
      if (selectedParcels.length === 0 || availableParcels.length === 0) {
        return true;
      }

      // Cria um mapa de posição das parcelas disponíveis
      // Ex: { 95: 0, 101: 1 } se as disponíveis são [95, 101]
      const positionMap = {};
      availableParcels.forEach((parcel, index) => {
        positionMap[parseInt(parcel.installmentNumber)] = index;
      });

      // Obtém as posições das parcelas selecionadas no array de disponíveis
      const selectedPositions = selectedParcels.map(parcel => {
        const installmentNumber = parseInt(parcel.installmentNumber);
        return positionMap[installmentNumber];
      }).filter(pos => pos !== undefined);

      // Verifica se as posições são consecutivas
      // Ex: Se selecionadas estão nas posições [0, 1], é válido
      // Ex: Se selecionadas estão nas posições [0, 2] (pulando 1), é inválido
      for (let i = 0; i < selectedPositions.length - 1; i++) {
        const currentPos = selectedPositions[i];
        const nextPos = selectedPositions[i + 1];

        // As posições devem ser consecutivas (diferença de 1)
        if (nextPos !== currentPos + 1) {
          console.log("[checkSequenceInAvailableInstallments] Sequência inválida:", {
            currentPos,
            nextPos,
            selectedParcels: selectedParcels.map(p => p.installmentNumber),
            availableParcels: availableParcels.map(p => p.installmentNumber)
          });
          return false;
        }
      }

      console.log("[checkSequenceInAvailableInstallments] Sequência válida:", {
        selectedParcels: selectedParcels.map(p => p.installmentNumber),
        availableParcels: availableParcels.map(p => p.installmentNumber),
        selectedPositions
      });

      return true;
    },

    home() {
      this.eventClickArrowToBackGTM();
      this.buildAndSetUserData(
        this.userDataStorage.cpfCnpj,
        this.userDataStorage.id,
        this.protocol + "//" + this.host + "/dashboard",
        "Dashboard"
      );
      this.updateCustomData();
      this.$router.push({
        name: "dashboard",
      });
    },

    buildAndSetUserData(doc, id, pageLocation, pageName) {
      // const pageName = this.$options.name;
      const userData = {
        cpfCnpj: doc, // Substitua pelo CPF/CNPJ real
        id: id, // Substitua pelo ID real
        page_location: pageLocation,
        pageName: pageName,
      };
      localStorage.setItem("userData", JSON.stringify(userData));
    },

    eventClickArrowToBackGTM() {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "click:button:voltar";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: "",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    eventClickNegociarGTM(offer) {
      this.pageName =
        localStorage.getItem("currentPageName") === null
          ? "dashboard"
          : localStorage.getItem("currentPageName");
      const eventCategory = `portal-de-negociacao:porto:${this.pageName}`;
      const eventAction = "click:button:negociar";

      const eventData = {
        event: "select_content",
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: this.buildPayloadOfferChoose(offer),
        product_identify: offer.contract,
        product_category: offer.product,
        product_user_profile: "titular",
        brand: "porto",
        product: offer.product,
        vertical: "bank",
      };

      window.dataLayer.push({ event: "select_content", ...eventData });
    },

    buildPayloadOfferChoose(offer) {
      var formatedPayload = null;
      if (offer.installmentsNumber === 1) {
        formatedPayload = "pagamento-a-vista";
      } else {
        formatedPayload = `parcelado-em-${offer.installmentsNumber}-vezes`;
      }
      return formatedPayload;
    },

    eventCallbackNegociarFailureGTM(error) {
      const pageName = this.$options.name;
      const eventCategory = `portal-de-negociacao:porto:${pageName}`;
      const eventAction = "solicitar-opcoes-pagamento:alert";
      const eventLabel = truncateString(
        "Não foi possível buscar ofertas, tente novamente mais tarde!",
        100
      );
      const eventCode = error.status;
      const eventErrorService = "";
      const eventAlertService = truncateString(error.data.message, 100);
      const eventAlert = "select_content";
      const eventAlertType = "erro";
      const eventData = {
        ev_category: eventCategory,
        ev_action: eventAction,
        ev_label: eventLabel,
        alert_code: eventCode,
        error_service: eventErrorService,
        alert_service_message: eventAlertService,
        alert_event: eventAlert,
        alert_type: eventAlertType,
      };

      window.dataLayer.push({ event: "alert", ...eventData });
    },

    updateCustomData() {
      const globals = initializeGlobals();
      window.customData = globals.customData;
    },

    async goToCardOfferUpdated() {
      const cardOfferDiv = document.getElementById("cardOfferUpdated");
      if (cardOfferDiv) {
        cardOfferDiv.scrollIntoView();
        cardOfferDiv.setAttribute("href", "#cardOfferUpdated");
      }
    },

    /**
     * Aplica seleção automática de parcelas C_PCTIPD=2 quando necessário
     * (quando há mais de um C_PCTIPD=1 selecionado em NAO CONTEMPLADO ou CONTEMPLADO SEM BEM)
     */
    applyAutoSelectInstallments(contract) {
      if (!contract || !contract.installments) {
        return;
      }

      const autoSelectInstallments = getAutoSelectInstallments(contract, this.checkedParcels);
      
      if (autoSelectInstallments.length > 0) {
        autoSelectInstallments.forEach(autoInst => {
          const alreadySelected = this.checkedParcels.some(
            p => p.installmentId === autoInst.installmentId
          );
          if (!alreadySelected) {
            this.checkedParcels.push(autoInst);
          }
        });
        
        // Atualiza o valor total
        this.valueTotal = 0;
        this.checkedParcels.map((value) => {
          this.valueTotal += parseFloat(value.originalValue, 10);
        });
        
        // Ativa o botão pulsante quando parcelas são adicionadas automaticamente
        this.needUpdate = true;
        
        this.$forceUpdate();
      }
    },
  },
  async created() {
    //eslint-disable-next-line
    // debugger;
    this.updateCustomData();
    this.ipUser = localStorage.getItem("ipUser");
    localStorage.setItem("currentPageName", this.$options.name);
    this.userDataStorage = JSON.parse(localStorage.getItem("userData"));
    this.userAdm = JSON.parse(localStorage.getItem("userAdm"));
    this.protocol = window.location.protocol;
    this.host = window.location.host;
    this.path = window.location.pathname;
    this.pageLocation = this.protocol + "//" + this.host + this.path;
    this.largura = window.screen.width;
    this.debtsConsorcio = this.$route.params.debtsConsorcio;
    this.agreements =
      typeof this.$route.params.agreements === "undefined"
        ? []
        : this.$route.params.agreements;
    this.offerInfo = this.$route.params.offerInfo;
    this.installmentsSelected = this.$route.params.installmentsSelected;
    this.sumTotalInstallmentsConsorcio = this.$route.params.sumTotalInstallmentsConsorcio;

    console.log("[PropostasConsorcio.created] debtsConsorcio: " + JSON.stringify(this.debtsConsorcio));
    console.log("[PropostasConsorcio.created] offerInfo: " + JSON.stringify(this.offerInfo));
    console.log("[PropostasConsorcio.created] sumTotalInstallmentsConsorcio: " + JSON.stringify(this.sumTotalInstallmentsConsorcio));
    console.log("[PropostasConsorcio.created] installmentsSelected:", this.installmentsSelected);
    console.log("[PropostasConsorcio.created] installmentsSelected type:", typeof this.installmentsSelected);
    console.log("[PropostasConsorcio.created] installmentsSelected length:", this.installmentsSelected?.length);
    console.log("[PropostasConsorcio.created] checkedParcels inicial:", this.checkedParcels.length);

    if (
      typeof this.installmentsSelected !== "undefined" &&
      this.installmentsSelected.length > 0
    ) {
      console.log("[PropostasConsorcio.created] Entrou no IF: há installmentsSelected, usando essas parcelas");
      // Se já há parcelas selecionadas vindas dos parâmetros da rota, usa essas
      this.debtsConsorcio[0].installments.map((item) => {
        this.installmentsSelected.map((installment) => {
          if (
            parseInt(item.installmentNumber) ===
            parseInt(installment.installmentNumber)
          ) {
            this.checkedParcels.push(item);
          }
        });
      });
      console.log("[PropostasConsorcio.created] checkedParcels após usar installmentsSelected:", this.checkedParcels.length);
      
      // Atualiza a propriedade parcelsIsFromCurrentContract para o contrato
      // Isso é necessário para que o template exiba corretamente os valores
      if (this.debtsConsorcio && this.debtsConsorcio.length > 0) {
        this.debtsConsorcio[0].parcelsIsFromCurrentContract = true;
        console.log("[PropostasConsorcio.created] parcelsIsFromCurrentContract atualizado para true (installmentsSelected)");
      }
      
      // Ativa o botão pulsante se houver parcelas selecionadas
      if (this.checkedParcels.length > 0) {
        this.needUpdate = true;
      }
      
      this.$forceUpdate();
    } else if (this.debtsConsorcio && this.debtsConsorcio.length > 0) {
      console.log("[PropostasConsorcio.created] Entrou no ELSE IF: não há installmentsSelected, aplicando seleção automática");
      // Se não há parcelas pré-selecionadas, aplica seleção automática inicial baseada nas regras
      const contract = this.debtsConsorcio[0];
      console.log("[PropostasConsorcio.created] Contract para análise:", {
        contract: contract.contract,
        type: contract.type,
        installmentsCount: contract.installments?.length
      });
      
      const initialInstallments = getInitialAutoSelectInstallments(contract);
      console.log("[PropostasConsorcio.created] initialInstallments retornado:", initialInstallments.length, initialInstallments);
      
      if (initialInstallments.length > 0) {
        console.log("[PropostasConsorcio.created] Há parcelas para selecionar automaticamente");
        // Seleciona todas as parcelas que devem ser selecionadas automaticamente
        initialInstallments.forEach(inst => {
          const alreadySelected = this.checkedParcels.some(
            p => p.installmentId === inst.installmentId
          );
          if (!alreadySelected) {
            console.log("[PropostasConsorcio.created] Adicionando parcela:", inst.installmentId, inst.installmentNumber);
            this.checkedParcels.push(inst);
          } else {
            console.log("[PropostasConsorcio.created] Parcela já estava selecionada:", inst.installmentId);
          }
        });
        
        console.log("[PropostasConsorcio.created] checkedParcels após adicionar:", this.checkedParcels.length);
        
        // Atualiza a propriedade parcelsIsFromCurrentContract para o contrato
        // Isso é necessário para que o template exiba corretamente os valores
        if (contract) {
          contract.parcelsIsFromCurrentContract = true;
          console.log("[PropostasConsorcio.created] parcelsIsFromCurrentContract atualizado para true");
        }
        
        // Atualiza o valor total
        this.valueTotal = 0;
        this.checkedParcels.map((value) => {
          this.valueTotal += parseFloat(value.originalValue, 10);
        });
        
        // Ativa o botão pulsante se houver parcelas selecionadas
        this.needUpdate = true;
        
        console.log("[PropostasConsorcio.created] valueTotal atualizado:", this.valueTotal);
        this.$forceUpdate();
      } else {
        console.log("[PropostasConsorcio.created] Nenhuma parcela retornada para seleção automática");
      }
    } else {
      console.log("[PropostasConsorcio.created] NÃO entrou em nenhum IF - debtsConsorcio:", this.debtsConsorcio);
    }

    // Aplica seleção automática de parcelas C_PCTIPD=2 se necessário (durante interação)
    if (this.debtsConsorcio && this.debtsConsorcio.length > 0) {
      const contract = this.debtsConsorcio[0];
      this.applyAutoSelectInstallments(contract);
    }
    // this.totalInstallmentsCdcWithFees =
    //   this.$route.params.totalInstallmentsCdcWithFees;
  },
  computed: {
    ...mapState("auth", ["user"]),
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
  },
};
</script>

<style scoped>
/* @media (max-width: 500px) {
  .card {
    margin-right: 0;
  }
} */

input[type="checkbox"] {
  /* appearance: none; */
  width: 20px;
  height: 20px;
  border: 3px solid #9ea7b1;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
}

input[type="checkbox"]:checked {
  background-color: #6e9ebf;
  border: none;
  /* position: relative; */
}

/* Parcelas que não podem ser desmarcadas: manter azul (não cinza) */
input[type="checkbox"]:disabled {
  border-color: #6e9ebf;
  opacity: 1;
  cursor: default;
}

input[type="checkbox"]:checked:disabled {
  background-color: #6e9ebf;
  border: none;
  opacity: 1;
}

input[type="checkbox"]:checked::before {
  /* Checkmark */
  content: "\2713";
  position: absolute;
  top: -2px;
  left: 3px;
  font-size: 18px;
  color: white;
}

.alert-flashing {
  animation: alert-flash 0.5s infinite alternate;
  width: 100%;
}

@keyframes alert-flash {
  0% {
    background-color: #e7ebfd;
    color: #0046c0;
  }

  100% {
    background-color: #a2b1d8;
    /* color: #fff; */
  }
}

.table-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.custom-table {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #dcdcdc;
  font-family: Arial, sans-serif;
  background-color: #eff0f2;
}

.table-row {
  display: flex;
  /* align-items: center; */
  border-bottom: 1px solid #eff0f2;
}

.table-header {
  background-color: #eff0f2;
  font-weight: bold;
  padding-top: 15px;
}

.table-cell {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  flex: 1;
  font-size: 9pt;
  color: black;
}

.table-cell.header {
  color: black;
  font-size: 8pt;
  font-weight: bold;
}

.table-cell:nth-child(1),
.table-cell:nth-child(3) {
  text-align: center;
}

.table-cell:nth-child(4) {
  /* font-weight: bold; */
  text-align: right;
}

.table-cell input[type="checkbox"] {
  width: 20px;
  height: 20px;
  -webkit-appearance: none;
  appearance: none;
  border: 2px solid #9ea7b1;
  border-radius: 3px;
  background: #fff;
  cursor: pointer;
  flex-shrink: 0;
}

.table-cell input[type="checkbox"]:checked {
  background-color: #0044cc;
  border-color: #0044cc;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-size: 14px 14px;
  background-position: center;
  background-repeat: no-repeat;
}

/* Parcelas que não podem ser desmarcadas (disabled): mesmo azul que as outras */
.table-cell input[type="checkbox"]:disabled {
  cursor: default;
  border-color: #9ea7b1;
}

.table-cell input[type="checkbox"]:checked:disabled {
  background-color: #0044cc;
  border-color: #0044cc;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-size: 14px 14px;
  background-position: center;
  background-repeat: no-repeat;
  opacity: 1;
}

.table-row:hover {
  background-color: #f1f5fb;
}

.alert-flashing {
  animation: alert-flash 0.5s infinite alternate;
}

/* @keyframes alert-flash {
  from {
    background-color: #ffeb3b;
  }
  to {
    background-color: #ff9800;
  }
} */

@media (max-width: 500px) {
  .custom-table .table-cell {
    font-size: 10px;
    padding: 3px;
  }
}
</style>
